// Minimum px of the panel's top-left corner that stays on-screen.
const MIN_VISIBLE = 40;

/**
 * Clamps a position so the panel's top-left corner stays on-screen.
 * @param {{ top: number, left: number }} pos
 * @returns {{ top: number, left: number }}
 */
export const clampPos = (pos) => ({
    left: Math.max(0, Math.min(pos.left, window.innerWidth - MIN_VISIBLE)),
    top: Math.max(0, Math.min(pos.top, window.innerHeight - MIN_VISIBLE)),
});

const MIN_WIDTH = 240;
const MIN_HEIGHT = 120;

/**
 * Clamps a size to a sane minimum.
 * @param {{ width: number, height: number }} size
 * @returns {{ width: number, height: number }}
 */
export const clampSize = (size) => ({
    width: Math.max(MIN_WIDTH, size.width),
    height: Math.max(MIN_HEIGHT, size.height),
});
